import { useState } from 'react'
import { UseFormReset } from 'react-hook-form'
import { getKyousouApiClient , ApiErrorResponse, handleError } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideExecutionPlan, ExecutionPlanFormData } from './types'
import { AiInstructionFormData } from '../common/types'

export const useExecutionPlanRegenerate = () => {
  const [isRegenerating, setIsRegenerating] = useState(false)
  const { showSnackBar } = useSnackBar()

  const regenerateExecutionPlan = async (
    id: string,
    aiInstruction: string,
    setSlideExecutionPlan: (slideExecutionPlan: SlideExecutionPlan) => void,
    resetAiForm: UseFormReset<AiInstructionFormData>,
    resetForm: UseFormReset<ExecutionPlanFormData>
  ) => {
    setIsRegenerating(true)
    const apiClient = getKyousouApiClient()

    try {
      const response = await apiClient.business.slideExecutionRegenerateCreate({
        businessIdeaId: id,
        aiInstruction: aiInstruction,
      })
      if (response.data?.executionPlan) {
        setSlideExecutionPlan(response.data.executionPlan)

        try {
            resetForm({
              resource: response.data.executionPlan.resource,
              maxPeriod: response.data.executionPlan.maxPeriod,
              scheduleItems: JSON.parse(response.data.executionPlan.scheduleItems || '[]'),
            })

            resetAiForm({ aiInstruction: '' })
            showSnackBar(['実行計画&必要なリソースのAI再生成が完了しました'], 'success', null) // 自動で消えない
          } catch (parseError) {
            console.error('JSONパースエラー:', parseError)
            showSnackBar(['実行計画&必要なリソースのデータの読み込みに失敗しました。'], 'error', null) // 自動で消えない
          }
      }
    } catch (e) {
      handleError(e as ApiErrorResponse, (messages, severity) => {
        showSnackBar(messages, severity, null) // 自動で消えない
      })
    } finally {
      setIsRegenerating(false)
    }
  }

  return {
    isRegenerating,
    regenerateExecutionPlan,
  }
}
